import { DriftClient } from '@drift-labs/sdk';
import { useCallback } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';

export const useSubscribeDriftClient = () => {
	const setDriftStore = useDriftStore((s) => s.set);

	const subscribeToDriftClientData = useCallback(
		async (driftClient: DriftClient) => {
			try {
				const subscriptionResult = await driftClient.subscribe();

				if (!subscriptionResult) {
					driftClient.unsubscribe();
				}

				setDriftStore((s) => {
					s.driftClient.isSubscribed = subscriptionResult;
				});

				return subscriptionResult;
			} catch (error) {
				console.error('Error subscribing to drift client data:', error);
				driftClient.unsubscribe();
				return false;
			}
		},
		[setDriftStore]
	);

	return { subscribeToDriftClientData };
};
